export const Navigation = ({
    onBack,
    onSkip,
    showBack,
    showSkip,
    totalSteps,
    currentStep,
    isFirstQuestion,
    showProgressDots,
    noCloseButton = false,
}) => {
    // Calculate weighted progress
    const getWeightedProgress = () => {
        if (currentStep === 0) return 0;
        
        // Calculate weights where earlier steps count for much more
        const weights = Array.from({ length: totalSteps }, (_, index) => {
            // Creates weights from 2.5 to 1 with exponential decay
            return 2.5 * Math.pow(0.9, index);
        });
        
        // Calculate progress based on weights
        const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);
        const currentWeight = weights.slice(0, currentStep).reduce((sum, weight) => sum + weight, 0);
        
        return (currentWeight / totalWeight) * 100;
    };

    const isLastTransition = currentStep === totalSteps;

    return (
        <div className="fixed left-0 right-0 px-4" style={{ top: '72px' }}>
            <div className="py-2 flex items-center">
                {/* Left side */}
                <div className="flex-1">
                    <button
                        onClick={onBack}
                        className={`p-2 rounded-lg transition-opacity text-black/20
                            ${showBack ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                    >
                        {isFirstQuestion ? noCloseButton ? null : (
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L13 13M1 13L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        ) : (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M19 12H5M12 19l-7-7 7-7"/>
                            </svg>
                        )}
                    </button>
                </div>
                
                {/* Progress Bar */}
                <div className={`w-1/2 h-1 bg-gray-200 rounded-full absolute left-1/2 -translate-x-1/2
                    transition-opacity duration-1000
                    ${isLastTransition ? 'opacity-0' : 'opacity-100'}`}>
                    <div 
                        className="h-full rounded-full bg-gray-800
                            transition-all duration-500 ease-out"
                        style={{ width: `${getWeightedProgress()}%` }}
                    />
                </div>
                
                {/* Right side */}
                <div className="flex-1 flex justify-end">
                    <button
                        onClick={onSkip}
                        className={`p-2 rounded-lg transition-opacity text-black/20
                            ${showSkip ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                    >
                        Skip
                    </button>
                </div>
            </div>
        </div>
    );
}; 